module.exports = __webpack_public_path__ + "static/media/title.d2f2461d.png";